import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';

import { CommentRefChatMessage } from '@/features/chats/components/CommentRefChatMessage';
import { GroupRefChatMessage } from '@/features/chats/components/GroupRefChatMessage';
import { PostRefChatMessage } from '@/features/chats/components/PostRefChatMessage';
import { isCommentRef, isGroupRef } from '@/features/chats/utils/entity';

type Props = {
  message: ClientChatMessage;
};

export const AutogeneratedChatMessage: FC<Props> = ({ message }) => {
  if (!message.referencedEntityId || !message.referencedEntityName) {
    return;
  }

  if (isCommentRef(message)) {
    return <CommentRefChatMessage message={message} />;
  } else if (isGroupRef(message)) {
    return <GroupRefChatMessage message={message} />;
  } else {
    return <PostRefChatMessage message={message} />;
  }
};
